import React from 'react';
import {ArticleApi, ArticleDto, ArticleStatus} from '../../scaffold';
import {Modal, Space, Table, Tag} from 'antd';
import {Result} from 'ahooks/lib/useAntdTable';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import ArticleEditForm from './EditForm';
import useAuth from '../../utils/AuthContext';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import CopyArticleBtn from './CopyBtn';
import DeleteArticleBtn from './DeleteBtn';

export default function ArticleTable(props: {antDTable: Result<ArticleDto>}) {
  const {tableProps, search, loading} = props.antDTable;
  const [editArticle, _editArticle] = React.useState<ArticleDto>();
  const updateStatusHook = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleUpdateStatusPost);
  const auth = useAuth();

  function updateStatus(id: number, status: ArticleStatus) {
    updateStatusHook
      .request({
        updateArticleStatusParams: {
          id,
          status,
        },
      })
      .then(res => {
        props.antDTable.refresh();
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <div>
      <Table<ArticleDto> {...tableProps} rowKey={'id'} bordered>
        <Table.Column<ArticleDto> title="ID" dataIndex="id" sorter width={80} />
        <Table.Column<ArticleDto> title="标题" sorter render={(_, item) => <Text strong>{item.title}</Text>} />
        <Table.Column<ArticleDto> title="发布版块" sorter dataIndex={['catalogs']} ellipsis width={100} />
        <Table.Column<ArticleDto>
          title="状态"
          sorter
          width={80}
          render={(_, item) => {
            if (item.status === ArticleStatus.待审) return <Tag color={'orange'}>待审</Tag>;
            if (item.status === ArticleStatus.隐藏) return <Tag color={'red'}>隐藏</Tag>;
            return <Tag color={'green'}>公开</Tag>;
          }}
        />
        <Table.Column<ArticleDto>
          title="发布时间"
          sorter
          width={130}
          key={'publishedDate'}
          render={(_, item) => <Text>{moment(item.publishedDate).format('YYYY-MM-DD')}</Text>}
        />
        <Table.Column<ArticleDto>
          title="操作选项"
          width={260}
          render={(text, row) => {
            return (
              <Space>
                <a onClick={() => _editArticle(row)}>编辑文章</a>
                {auth.currentUser?.isSu && (
                  <>
                    <CopyArticleBtn id={row.id as number} refresh={props.antDTable.refresh} />
                    {row.status === ArticleStatus.公开 && <a onClick={() => updateStatus(row.id as number, ArticleStatus.隐藏)}>设为隐藏</a>}
                    {row.status === ArticleStatus.隐藏 && <a onClick={() => updateStatus(row.id as number, ArticleStatus.公开)}>设为公开</a>}
                    {row.status === ArticleStatus.待审 && <a onClick={() => updateStatus(row.id as number, ArticleStatus.公开)}>审核通过</a>}
                    <DeleteArticleBtn id={row.id as number} refresh={props.antDTable.refresh} />
                  </>
                )}
              </Space>
            );
          }}
        />
      </Table>
      <Modal title={'编辑文章'} destroyOnClose width={1200} visible={!!editArticle} maskClosable={false} closable={false} footer={false}>
        {editArticle && (
          <ArticleEditForm
            article={editArticle}
            catalogs={editArticle?.catalogs || ''}
            onCancel={() => _editArticle(undefined)}
            onSuccess={res => {
              _editArticle(undefined);
              props.antDTable.search.submit();
            }}
          />
        )}
      </Modal>
    </div>
  );
}
